import {useQuery} from 'react-query'
import {Get} from '../../../../setup'
import {CallTrackingCallTime, CallTrackingDashboardData, initialCallTrackingDashboardData} from '../../../@types'
import {processCallTime, processDataTable} from '../../../pages/call-tracking/utils'
import {LoadingState, PeriodType} from '../../../../global'
import {Dispatch, SetStateAction, useState} from 'react'

const CALL_TRACKING_GENERAL = process.env.REACT_APP_V2_DASHBOARD_CALL_TRACKING || 'v2/calltraking'

type Props = {
    period: PeriodType
    setLoading: Dispatch<SetStateAction<LoadingState>>
}

export const useCallTrackingData = ({period, setLoading}: Props) => {

    const [callTime, setCallTime] = useState<CallTrackingCallTime>({
        hour: 0, minute: 0, second: 0,
    })
    const [data, setData] = useState<CallTrackingDashboardData>(initialCallTrackingDashboardData)
    const [error, setError] = useState<string | null>(null);

    const {refetch} = useQuery(
        ['CALL_TRACKING_GENERAL', period],
        () => Get<CallTrackingDashboardData>({endpoint: CALL_TRACKING_GENERAL, period}),
        {
            enabled: !!period.start && !!period.end,
            onSuccess: (data) => {
                setLoading('fulfilled')
                setCallTime(processCallTime(data.cards.callTime))
                setData(prev => ({
                    ...data,
                    dataTable: processDataTable(data.dataTable),
                }))
                setError(null);
            },
            onError: (err: any) => {
                setLoading('rejected')
                setError(err.message || 'Une erreur est survenue')
            },
        },
    )

    return {data, callTime, refetch, error}
}